<p>pgn-layer-manager-panel works!</p>
